﻿
(function ($, document, undefined) {
    $(document).ready(function () {
        $(document).on('input', '[data-cc-subscription-amount]', function (e) {
            var subscriptionAmount = $(this).val();
            $('.button--selected[data-cc-subscription-amount-option]').removeClass('button--selected');
            if (subscriptionAmount - 0 > 0) {
                $('[data-cc-subscription-amount-option=' + subscriptionAmount + ']').addClass('button--selected');
            }
        });

        $(document).on('change', '.js-cc-subscription-amount', function (e) {
            var subscriptionAmount = $(this).val();
            $('.js-cc-help-text').each(function (i, n) {
                var $helpText = $(this);
                $helpText.text(
                    Mustache.render(
                        $helpText.data('template'), {
                            SubscriptionAmount: subscriptionAmount
                        }
                    )
                );
            });
        });

        $(document).on('change', '.js-cc-payment-methods', function (e) {
            $('option', $(this)).each(function (i, n) {
                var $option = $(this);
                if ($option.is(':selected')) {
                    $($option.data('cc-payment-elements')).show();
                } else {
                    $($option.data('cc-payment-elements')).hide();
                }
            });
        });

        $(document).on('click', '[data-cc-subscription-amount-option]', function (e) {
            e.preventDefault();
            var $btn = $(this);
            var amount = $btn.data('cc-subscription-amount-option');
            $('[data-cc-subscription-amount]').val(amount).trigger('change');
            $('.button--selected[data-cc-subscription-amount-option]').removeClass('button--selected');
            $btn.addClass('button--selected');
        });

        $('[data-cc-subscription-amount]').trigger('change');
        $('.js-cc-payment-methods').trigger('change');
    });
})(jQuery, document);